<div class="container-fluid py-3 p-lg-4">
  <div class="row">
    <div class="col-12 col-sm-3 text-center">
      <img ngSrc="assets/images/inspector-inviting.svg" alt="Bactoforce Inspector" i18n-alt class="image-mascot" priority
           width="483" height="466"/>
    </div>
    <div class="col-12 col-sm-6 text-center">
      <h1 class="mt-4" i18n>Welcome to R-Force</h1>
      <button type="button" class="btn btn-lg btn-outline-secondary mt-4 mt-md-5" routerLink="/login" i18n>Login</button>
      <p class="lead mt-4 mt-md-5" i18n>Login to access your inspection data</p>
      <p class="hint" i18n>(For support please contact your local Bactoforce office)</p>
    </div>
    <div class="col-12 col-sm-3 text-center">
      <img ngSrc="assets/images/rforce-logo.svg" alt="R-Force Logo" i18n-alt class="image-logo" priority width="177"
           height="155"/>
    </div>
  </div>

  <div class="row mt-4 mt-md-5">
    <div class="col-12 col-sm-4">
      <h2 i18n>Inspection Overview</h2>
      <p i18n>Easy access to manage and view inspections</p>
      <ul>
        <li i18n>Clear overview of all your equipment and status of the latest visit</li>
        <li i18n>Monitor inspection results and inspection history</li>
        <li i18n>Manage your dynamic inspection plan</li>
      </ul>
    </div>
    <div class="col-12 col-sm-4">
      <h2 i18n>Inspection Reports</h2>
      <p i18n>
        Easy access to view and download of your inspection reports with documentation,
        photos and recommended actions in PDF-format.
        Always accessible by computer, tablet and mobile phone.
      </p>
    </div>
    <div class="col-12 col-sm-4">
      <h2 i18n>Service Portfolio</h2>
      <p i18n>
        Bactoforce has a portfolio of inspection services customized for the food industry.
        Take a closer look on our homepage and get inspiration on how to reduce equipment downtime, maintenance and
        risks related to product safety.
        <span class="important">We call it Hygienic Maintenance.</span>
      </p>
      <a href="https://bactoforce.com/services" target="_blank"
         class="btn btn-outline-secondary d-inline-flex justify-content-between align-items-center gap-1">
        <span class="text-break" i18n>Our services</span>
        <i rfBsIcon="caret-right" class="lh-1"></i>
      </a>
    </div>
  </div>

  <div class="row justify-content-center mt-5">
    <div class="col-auto hstack flex-wrap justify-content-center gap-4 text-center">
      <a href="https://www.linkedin.com/company/bactoforce" target="_blank">
        <img ngSrc="assets/images/linkedin.svg" alt="Connect with us and stay updated on LinkedIn" i18n-alt
             class="social-icon" width="91" height="90"/>
      </a>
      <a href="https://www.facebook.com/Bactoforce-2237126446502875" target="_blank">
        <img ngSrc="assets/images/facebook.svg" alt="Connect with us and stay updated on Facebook" i18n-alt
             class="social-icon" width="2048" height="2048"/>
      </a>
    </div>
  </div>
</div>
